const SMARTTASK_COLDSTART_LOG_PREFIX = 'SMARTTASK_';

function getWindowWithColdStartDiagnostics() {
  if (typeof window === 'undefined') {
    return null;
  }

  return window as typeof window & {
    __coldStartDiagnosticsEnabled?: boolean;
    __coldStartLog?: (tag: string, msg: string, data?: unknown) => void;
    __shipColdStartLogs?: (options?: { trigger?: string; forceAll?: boolean; keepLogs?: boolean }) => void;
  };
}

export function isSmartTaskColdStartDiagnosticsEnabled(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  if ((window as typeof window & { __coldStartDiagnosticsEnabled?: boolean }).__coldStartDiagnosticsEnabled === false) {
    return false;
  }

  if (typeof process !== 'undefined' && process.env.NODE_ENV === 'development') {
    return true;
  }

  try {
    const host = window.location.hostname.toLowerCase();
    return host === 'localhost'
      || host === '127.0.0.1'
      || host.startsWith('dev-') || host === 'dev.totalaccess.co.za'
      || host.includes('dev-app') || host === 'dev.totalaccess.co.za'
      || window.localStorage.getItem('debug_smarttask_coldstart') === 'true';
  } catch {
    return false;
  }
}

export function getSmartTaskColdStartNow(): number {
  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    return performance.now();
  }

  return Date.now();
}

export function writeSmartTaskColdStartLog(tag: string, msg: string, data?: Record<string, unknown>): void {
  if (!isSmartTaskColdStartDiagnosticsEnabled()) {
    return;
  }

  const diagnosticsWindow = getWindowWithColdStartDiagnostics();
  const coldStartLogger = diagnosticsWindow?.__coldStartLog;
  if (typeof coldStartLogger !== 'function') {
    return;
  }

  try {
    coldStartLogger(`${SMARTTASK_COLDSTART_LOG_PREFIX}${tag}`, msg, data);
  } catch {
    // Diagnostics must never break the app.
  }
}

export function writeSmartTaskColdStartDuration(
  tag: string,
  msg: string,
  startedAt: number,
  data?: Record<string, unknown>,
): void {
  writeSmartTaskColdStartLog(tag, msg, {
    ...data,
    durationMs: Math.max(0, Math.round(getSmartTaskColdStartNow() - startedAt)),
  });
}

export function shipSmartTaskColdStartLogs(trigger: string, options?: { keepLogs?: boolean }): void {
  if (!isSmartTaskColdStartDiagnosticsEnabled()) {
    return;
  }

  const diagnosticsWindow = getWindowWithColdStartDiagnostics();
  const shipper = diagnosticsWindow?.__shipColdStartLogs;
  if (typeof shipper !== 'function') {
    return;
  }

  window.setTimeout(() => {
    try {
      shipper({
        trigger,
        forceAll: true,
        keepLogs: options?.keepLogs !== false,
      });
    } catch {
      // Ignore shipping failures.
    }
  }, 2500);
}